// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file webgame/v1/session.proto (package webgame.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AuthResponseSchema } from "../../player/v1/player_pb";
import { file_player_v1_player } from "../../player/v1/player_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file webgame/v1/session.proto.
 */
export const file_webgame_v1_session: GenFile = /*@__PURE__*/
  fileDesc("Chh3ZWJnYW1lL3YxL3Nlc3Npb24ucHJvdG8SCndlYmdhbWUudjEiKgoNU2lnbkluUmVxdWVzdBIZChFmaXJlYmFzZV9pZF90b2tlbhgBIAEoCSInCg5SZWZyZXNoUmVxdWVzdBIVCg1yZWZyZXNoX3Rva2VuGAEgASgJIicKDlNpZ25PdXRSZXF1ZXN0EhUKDXJlZnJlc2hfdG9rZW4YASABKAkiEQoPU2lnbk91dFJlc3BvbnNlMtUBChFXZWJTZXNzaW9uU2VydmljZRI8CgZTaWduSW4SGS53ZWJnYW1lLnYxLlNpZ25JblJlcXVlc3QaFy5wbGF5ZXIudjEuQXV0aFJlc3BvbnNlEj4KB1JlZnJlc2gSGi53ZWJnYW1lLnYxLlJlZnJlc2hSZXF1ZXN0GhcucGxheWVyLnYxLkF1dGhSZXNwb25zZRJCCgdTaWduT3V0Ehoud2ViZ2FtZS52MS5TaWduT3V0UmVxdWVzdBobLndlYmdhbWUudjEuU2lnbk91dFJlc3BvbnNlQjdaNWdpdGh1Yi5jb20vbWFmaWFnby9zZXJ2ZXIvZ2VuL2dvL3dlYmdhbWUvdjE7d2ViZ2FtZXYxYgZwcm90bzM", [file_player_v1_player]);

/**
 * @generated from message webgame.v1.SignInRequest
 */
export type SignInRequest = Message<"webgame.v1.SignInRequest"> & {
  /**
   * @generated from field: string firebase_id_token = 1;
   */
  firebaseIdToken: string;
};

/**
 * Describes the message webgame.v1.SignInRequest.
 * Use `create(SignInRequestSchema)` to create a new message.
 */
export const SignInRequestSchema: GenMessage<SignInRequest> = /*@__PURE__*/
  messageDesc(file_webgame_v1_session, 0);

/**
 * @generated from message webgame.v1.RefreshRequest
 */
export type RefreshRequest = Message<"webgame.v1.RefreshRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message webgame.v1.RefreshRequest.
 * Use `create(RefreshRequestSchema)` to create a new message.
 */
export const RefreshRequestSchema: GenMessage<RefreshRequest> = /*@__PURE__*/
  messageDesc(file_webgame_v1_session, 1);

/**
 * @generated from message webgame.v1.SignOutRequest
 */
export type SignOutRequest = Message<"webgame.v1.SignOutRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message webgame.v1.SignOutRequest.
 * Use `create(SignOutRequestSchema)` to create a new message.
 */
export const SignOutRequestSchema: GenMessage<SignOutRequest> = /*@__PURE__*/
  messageDesc(file_webgame_v1_session, 2);

/**
 * @generated from message webgame.v1.SignOutResponse
 */
export type SignOutResponse = Message<"webgame.v1.SignOutResponse"> & {
};

/**
 * Describes the message webgame.v1.SignOutResponse.
 * Use `create(SignOutResponseSchema)` to create a new message.
 */
export const SignOutResponseSchema: GenMessage<SignOutResponse> = /*@__PURE__*/
  messageDesc(file_webgame_v1_session, 3);

/**
 * WebSessionService is the browser client's sign-in. Served by cmd/auth.
 *
 * Why not PlayerService.LoginWithGoogle / RefreshToken / PlayerLogout:
 *   - LoginWithGoogle CREATES a player when no identity exists. The web is a
 *     companion for existing players, so SignIn is lookup-only and answers
 *     web_no_account instead.
 *   - PlayerLogout also revokes the phone's background-location token.
 *     SignOut revokes this one refresh token and nothing else.
 *   - Tokens issued here carry scope "web": a read-only RPC allowlist in the
 *     auth interceptor, refused by the realtime socket and the location
 *     reporter, and not exchangeable through PlayerService.RefreshToken.
 *
 * All three RPCs are public (no JWT required).
 *
 * @generated from service webgame.v1.WebSessionService
 */
export const WebSessionService: GenService<{
  /**
   * Exchanges a Firebase ID token (Google or email/password sign-in) for a
   * web-scoped session. Errors (x-mafiago-error-code):
   *   web_no_account        — no MafiaGo account for this identity (NotFound)
   *   web_setup_incomplete  — param step=faction|age (FailedPrecondition)
   *   account_deleted / the usual login status gates
   *
   * @generated from rpc webgame.v1.WebSessionService.SignIn
   */
  signIn: {
    methodKind: "unary";
    input: typeof SignInRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * Rotates a web refresh token. Refuses non-web tokens.
   *
   * @generated from rpc webgame.v1.WebSessionService.Refresh
   */
  refresh: {
    methodKind: "unary";
    input: typeof RefreshRequestSchema;
    output: typeof AuthResponseSchema;
  },
  /**
   * Revokes exactly this refresh token. Never touches mobile sessions or the
   * background-location token.
   *
   * @generated from rpc webgame.v1.WebSessionService.SignOut
   */
  signOut: {
    methodKind: "unary";
    input: typeof SignOutRequestSchema;
    output: typeof SignOutResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_webgame_v1_session, 0);

